import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Constants from "../Utilities/Constants";
import Product from "../Components/Product";
import SideBarGallery from "../Components/SideBar";
import Banners from "../Components/Banners";
import LoadingScreen from '../Components/LoadingScreen';
import { useAppContext } from "../Contexts/AppContext";
import Popup from "../Components/Popup";
import { usePageTitle } from "../Utilities/usePageTitle";

const HomePage = () => {
    usePageTitle(null);
    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const { isInitialized } = useAppContext(); 
    const [isLargeScreen] = useState(() => window.innerWidth > 768);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await axios.get(Constants.API_URL_GET_HOMEPAGE_PRODUCTS);
                setProducts(response.data);
            } catch(error) {
                console.error("Error loading products:", error);
                setProducts([]);
            }
        }

        const loadData = async () => {
            setIsLoading(true);
            try {
                await fetchProducts();
            } catch (error) {
                console.error('Error loading homepage data:', error);
            } finally {
                setIsLoading(false);
            }
        };

        if (isInitialized) {
            loadData();
        }
    }, [isInitialized]);

    return (
        <>
            {/* Homepage popup - change `furl` to the page slug you want to show */}
            <Popup furl={"פופאפ-בדף-הבית"} />
            {isLargeScreen 
            ? <Banners galleryName="באנרים-דף-הבית" />
            : <Banners galleryName="באנרים-דף-הבית-ניידים" />
            }
            <div className="container py-2">
                <div className="row">
                    <div className="col-md-2 text-center desktop shadow">
                        <div className="d-flex flex-wrap justify-content-around w-100">
                            <SideBarGallery />
                        </div>
                    </div>
                    {isLoading ? (
                        <LoadingScreen loading={isLoading} message="טוען מוצרים..." />
                    ) : (
                    <div className="col-md-10">                    
                        <h4 className="line-decoration">המומלצים שלנו</h4>
                        <br/>
                        <div className="d-flex flex-wrap justify-content-around w-100">
                            {products.length > 0 ? (
                                products.map((product, key) => (
                                    <Product 
                                        product={product}
                                        key={product.id}
                                        category={null} 
                                        subcategory={null}
                                    />
                                ))
                            ) : (
                                <div className="text-center p-4">
                                    <p>לא נמצאו מוצרים להצגה</p>
                                </div>
                            )}
                        </div>
                        <div className="container py-4 home-categories">
                            <h4 className="line-decoration">הקטגוריות שלנו</h4>
                            <div className="d-flex flex-wrap justify-content-around w-100">
                                <HomeBanners />
                            </div>
                        </div>
                    </div>
                    )}
                </div>
            </div>
        </>
    )
}

const HomeBanners = () => {
    const [gallery, setGallery] = useState([]);

    useEffect(() => {
        const fetchGallery = async () => {
            var url = `${Constants.API_URL_GET_GALLERY}/קטגוריות-ראשיות`;
            try {
                const response = await axios.get(url);
                setGallery(response.data);
            }
            catch(error) {
                console.error('Error fetching home categories:', error);
                setGallery([]);
            }
        }

        fetchGallery();
    }, [])

    return (
        gallery.map((image, key) => (
            <Link to={image.imageLink} key={key} className="category-box">
                <img 
                    src={`${Constants.IMAGE_URL}${image.fileName}`}  
                    alt={image.imageTitle} 
                />
            </Link>
        ))
    )
}

export default HomePage;
